'use client'

import { createContext } from 'react'

/**
 * 레이어 판의 머리 칸 — layer-host 가 본문 스크롤 칸 위(스크롤 밖)에 두고 그 요소를 내려 준다.
 * SheetHead 가 여기로 포털해 그려져, 본문만 안에서 스크롤되고 머리 아래 선에서 잘린다.
 * null 이면(레이어 밖 · 시트 안 가려진 화면) 머리는 제자리에 그린다.
 */
export const LayerHeadSlot = createContext<HTMLElement | null>(null)
